import PropTypes           from 'prop-types'
import React               from 'react'
import { connect         } from 'react-redux'
import { Row, Col, Alert } from 'react-bootstrap'
import IdleTimer           from 'react-idle-timer'

import { dispatchToProps                          } from 'alto-utils/lib/store'
import { loadCanteenData, loadMenu, forgetMenu,
         selectDate, resetCanteenAndDateSelection } from 'alto-react-canteen/lib/store'
import { menuSetting                              } from 'alto-react-canteen/lib/settings'

import DateSelection      from './date_selection'
import LoggedOutDailyMenu from './logged_out_daily_menu'

class LoggedOutMenu extends React.Component
  @contextTypes = { backend: PropTypes.object, settings: PropTypes.object }

  constructor: (props, context) ->
    super(props, context)

    setting = menuSetting(context.settings)

    @refreshPeriod = setting.refreshPeriod
    @alergensUrl   = setting.alergens.linkUrl

  componentWillMount: ->
    @promise = @props.loadCanteenData(@context.backend, @context.settings, false)

  componentWillUnmount: ->
    @cancelAsyncTasks()
    @props.forgetMenu()

  render: ->
    if @props.menu and @props.selectedDate and @props.selectedCanteenID
      <React.Fragment>
        {@additionalRenderAbove()}
        {@menu()}
        {@alergensLink()}
      </React.Fragment>
    else
      @loadingAlert()

  additionalRenderAbove: ->
    @idleTimer()

  menu: ->
    canteenMenu = @props.menu.forCanteen(@props.selectedCanteenID)
    dailyMenu   = canteenMenu.dailyMenuFor(@props.selectedDate)

    <React.Fragment>
      <Row className='date-selection'><Col xs={12}>{@dateSelection(canteenMenu)}</Col></Row>
      <Row className='daily-menu'>    <Col xs={12}>{@dailyMenu(dailyMenu)}      </Col></Row>
    </React.Fragment>

  loadingAlert: ->
    if @props.menu
      text = 'Menu na tento týden zatím není k dispozici.'
    else
      text = 'Načítám denní menu.'

    <Row><Col xs={12}>
      <Alert bsStyle="info" className="menu-alert">{text}</Alert>
    </Col></Row>

  dateSelection: (canteenMenu) ->
    <DateSelection
     menu={canteenMenu}
     selectedDate={@props.selectedDate}
     onSelect={@props.selectDate} />

  dailyMenu: (dailyMenu) ->
    <LoggedOutDailyMenu menu={dailyMenu} />

  alergensLink: ->
    if @alergensUrl
      <p>Seznam alergenů k nahlédnutí <a href={@alergensUrl} target='_blank'>zde</a></p>

  idleTimer: ->
    <IdleTimer
     onIdle={=> @refreshTimer = setInterval(@refreshMenu.bind(@), @refreshPeriod * 1000)}
     onActive={@cancelAsyncTasks.bind(@)}
     debounce={250}
     timeout={10 * 1000} />

  refreshMenu: ->
    @promise = @props.loadMenu(@context.backend, @context.settings, false).then =>
      @props.resetCanteenAndDateSelection(true) if @props.terminal

  cancelAsyncTasks: ->
    @promise?.cancel?()
    clearInterval(@refreshTimer) if @refreshTimer

mapStateToProps = (state) ->
  _.pick(state.canteen, 'menu', 'terminal', 'selectedDate', 'selectedCanteenID')

mapDispatchToProps = dispatchToProps({ loadCanteenData, loadMenu, forgetMenu,
                                       selectDate, resetCanteenAndDateSelection })

export default connect(mapStateToProps, mapDispatchToProps)(LoggedOutMenu)
